/* danchel — 3D-Szenen für Shopify-Sections.
   Initialisiert alles, was ein data-dan3d-Attribut trägt. Braucht THREE + danchel-3d-core.js. */
(function(){
  function boot(){
    if(!window.DAN || !window.THREE) return;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- Hero: drehbarer Stick --- */
    document.querySelectorAll('[data-dan3d="hero"]').forEach(function(cv){
      if(cv.dataset.ready) return; cv.dataset.ready = '1';
      var S = DAN.scene(cv, {camZ:9.2, camY:.25});
      var st = DAN.stick();
      S.scene.add(st.group); S.scene.add(DAN.shadow(-1.92));
      var spin = DAN.spin(cv, st.group, .0035), t0 = 0;
      (function loop(t){
        requestAnimationFrame(loop);
        if(!S.live()) return;
        var dt = Math.min((t - t0) / 16.7, 3); t0 = t;
        if(!reduce){
          spin(dt);
          st.group.rotation.x = Math.sin(t / 2600) * .06;
          st.group.position.y = Math.sin(t / 1800) * .07;
        }
        S.draw();
      })(0);
      if(document.fonts) document.fonts.ready.then(function(){
        st.mats[0].map = DAN.labelTexture(); st.mats[0].needsUpdate = true; S.resize();
      });
    });

    /* --- Explosionsansicht --- */
    document.querySelectorAll('[data-dan3d="explosion"]').forEach(function(cv){
      if(cv.dataset.ready) return; cv.dataset.ready = '1';
      var root = cv.closest('[data-dan-expl]');
      var S = DAN.scene(cv, {camZ:9.6, camY:.4, fov:30});
      var st = DAN.stick(); st.group.add(st.cap);
      S.scene.add(st.group); S.scene.add(DAN.shadow(-2.15, 4));
      var spin = DAN.spin(cv, st.group, .0028);
      var bar = root.querySelector('.expl__track i');
      var lbls = root.querySelectorAll('.expl__lbl');
      var p = 0, t0 = 0;
      function prog(){
        var r = root.getBoundingClientRect(), span = r.height - innerHeight;
        return span <= 0 ? 1 : Math.max(0, Math.min(1, -r.top / span));
      }
      (function loop(t){
        requestAnimationFrame(loop);
        if(!S.live()) return;
        var dt = Math.min((t - t0) / 16.7, 3); t0 = t;
        p += ((reduce ? 1 : prog()) - p) * .09;
        var e = Math.min(1, p * 1.25);
        st.cap.position.y = e * 2.35;
        st.core.position.y = e * .78;
        st.group.position.y = -e * .35;
        if(!reduce) spin(dt);
        if(bar) bar.style.setProperty('--p', p.toFixed(3));
        [.30, .45, .60].forEach(function(gate, i){
          if(lbls[i]) lbls[i].classList.toggle('on', p > gate);
        });
        S.draw();
      })(0);
    });

    /* --- Wirkstoff-Orbit --- */
    document.querySelectorAll('[data-dan3d="orbit"]').forEach(function(cv){
      if(cv.dataset.ready) return; cv.dataset.ready = '1';
      var root = cv.closest('[data-dan-orbit]');
      var pins = root.querySelectorAll('.orbit__pin');
      var cards = root.querySelectorAll('.orbit__c');
      var tints = [0xF7A8CC, 0xF9C7DC, 0xFBDCE8, 0xF3B8D6];
      var S = DAN.scene(cv, {camZ:8.4, camY:0, fov:34});
      var orbs = [], n = Math.max(1, pins.length);
      for(var i = 0; i < n; i++){
        var o = new THREE.Mesh(new THREE.SphereGeometry(.86, 64, 48),
          new THREE.MeshPhysicalMaterial({color:tints[i % 4], roughness:.06, clearcoat:1,
            clearcoatRoughness:.04, transparent:true, opacity:.62}));
        o.userData = {a:i / n * Math.PI * 2, y:(i % 2 ? .5 : -.5) * .7, hot:1};
        S.scene.add(o); orbs.push(o);
      }
      var dust = [];
      for(var k = 0; k < 12; k++){
        var d = new THREE.Mesh(new THREE.SphereGeometry(.07 + Math.random() * .11, 20, 14),
          new THREE.MeshPhysicalMaterial({color:0xffffff, roughness:.05, clearcoat:1, transparent:true, opacity:.35}));
        d.userData = {a:Math.random() * 6.28, d:3 + Math.random() * 1.5, y:(Math.random() - .5) * 3, s:.3 + Math.random() * .6};
        S.scene.add(d); dust.push(d);
      }
      var hot = -1;
      cards.forEach(function(c, i){
        c.addEventListener('pointerenter', function(){ hot = i; });
        c.addEventListener('pointerleave', function(){ hot = -1; });
      });
      var v = new THREE.Vector3(), t0 = 0, spin = 0;
      (function loop(t){
        requestAnimationFrame(loop);
        if(!S.live()) return;
        var dt = Math.min((t - t0) / 16.7, 3); t0 = t;
        if(!reduce) spin += .0022 * dt;
        var r = cv.getBoundingClientRect();
        orbs.forEach(function(o, i){
          var u = o.userData, ang = u.a + spin;
          o.position.set(Math.cos(ang) * 2.5, u.y + (reduce ? 0 : Math.sin(t / 2100 + i) * .18), Math.sin(ang) * 2.5);
          u.hot += (((hot === i) ? 1.24 : 1) - u.hot) * .12;
          o.scale.setScalar(u.hot);
          o.material.opacity = .62 + (u.hot - 1) * 1.1;
          v.copy(o.position).project(S.cam);
          if(pins[i]){
            pins[i].style.transform = 'translate(-50%,-50%) translate(' +
              ((v.x * .5 + .5) * r.width) + 'px,' + ((-v.y * .5 + .5) * r.height + 76) + 'px)';
            pins[i].classList.add('vis');
            pins[i].classList.toggle('hot', hot === i);
          }
        });
        dust.forEach(function(d, i){
          var u = d.userData, ang = u.a + spin * u.s;
          d.position.set(Math.cos(ang) * u.d, u.y + Math.sin(t / 2600 + i) * .2, Math.sin(ang) * u.d - .5);
        });
        S.draw();
      })(0);
    });
  }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
